import { mutatorAction } from "satcheljs";
import { shiftEditorViewState } from "..";

export default mutatorAction("updateShiftFormErrors", function updateShiftFormErrors(errorCount: number) {
    shiftEditorViewState().shiftFormErrors = errorCount;
});